import { BankIcon } from "@phosphor-icons/react/dist/csr/Bank";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

interface EmptyPaymentStateProps {
  className?: string;
  onAddBankDetails: () => void;
}

export const EmptyPaymentState = ({
  className,
  onAddBankDetails,
}: EmptyPaymentStateProps) => (
  <Empty className={emptyStateVariants({ layout: "panel", className })}>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <BankIcon aria-hidden />
      </EmptyMedia>
      <EmptyTitle>No banking information added</EmptyTitle>
      <EmptyDescription>
        Add your banking details to enable deposits and withdrawals for referral
        payments.
      </EmptyDescription>
    </EmptyHeader>
    <EmptyContent>
      <Button onClick={onAddBankDetails}>Add bank details</Button>
    </EmptyContent>
  </Empty>
);
